<template>
    <div class="pm-register">
        <div class="reg-main-title">
            面辅料代购<span>专属入驻通道</span>
        </div>
        <div class="reg-sub-desc">
            面辅料代购专属平台，一站对接供需，入驻平台即享海量商机，高效赚收益
        </div>
        <div class="reg-btn" @click="onApply" v-if="status==-1">申请入驻</div>
        <div v-if="status==2 || status==0" class="apply-progress" @click="onCheck">查看申请进度</div>
    </div>
</template>
<script>
import { RegisterCheck } from '@/api/procurement';
import { mapState } from 'vuex';
export default{
    data(){
        return{
            status:-1
        }
    },
    computed:{
        ...mapState({
            userInfo:state=>state.userInfo,
            is_login:state=>state.is_login
        })
    },
    mounted(){
      if(this.is_login) {
        this.getCheckInfo();
      }
    },
    methods:{
        async getCheckInfo(){
            try{
                const {code,data} = await RegisterCheck();
                this.status = data.status;
                if(this.status== 1) {
                  return this.$layer.msg('您的申请已通过');
                }
            }catch(e){
                console.log('err',e);
            }
        },
        async onCheck(){
           this.$router.push({name:'ProcurementResult'})
        },
        async onApply(){
            if(!this.userInfo.id){
                this.$layer.msg('请先注册成为平台用户或登录再操作');
                this.$router.push({name:"Login",query:{back_name:'ProcurementApply',type:'wechat'}});
                return;
            }
            
            this.$router.push({
              name:"ProcurementRegister"
            })
        }
    }
}
</script>
<style lang="scss" scoped>
.pm-register{
    width:100%;
    height:calc(100vh - 60px - 50px);
    background:url('../../assets/images/procurement/bg.png') no-repeat;
    background-size:cover;
    background-position:center;
    display:flex;
    // justify-content:center;
    align-items:center;
    flex-direction:column;
    .reg-main-title{
        color:#000;
        font-size:58px;
        font-weight:bold;
        display:flex;
        align-items:center;
        margin-top:234px;
        span{
            color:#1b7bf8;
        }
    }
    .reg-sub-desc{
        margin-top:30px;
        color:#000;
        font-size:24px;
    }
    .reg-btn{
        width:320px;
        height:56px;
        line-height:56px;
        border-radius:16px;
        color:#fff;
        background:#ff5967;
        cursor:pointer;
        margin-top:77px;
        text-align:center;
        font-size:18px;
        font-weight:bold;
    }
    .apply-progress{
        margin-top:24px;
        color:#0d99ff;
        cursor:pointer;
        text-decoration: underline;
    }
}
@media (min-width: 1280px) and (max-width: 1679px) {
  .pm-register {
    .reg-main-title {
      font-size: 42px; /* 缩小标题字体 */
      margin-top: 180px; /* 减少上边距 */
      
      span {
        font-size: 42px; /* 保持一致 */
      }
    }
    
    .reg-sub-desc {
      font-size: 20px; /* 缩小副标题字体 */
      margin-top: 24px; /* 调整间距 */
    }
    
    .reg-btn {
      width: 280px; /* 调整按钮宽度 */
      height: 50px; /* 调整按钮高度 */
      line-height: 50px;
      font-size: 16px; /* 调整按钮字体 */
      margin-top: 60px; /* 调整按钮上边距 */
    }
    
    .apply-progress {
      font-size: 14px; /* 调整链接字体 */
      margin-top: 20px; /* 调整间距 */
    }
  }
}
@media (max-width: 1279px) {
  .pm-register {
    .reg-main-title {
      font-size: 36px; /* 进一步缩小标题字体 */
      margin-top: 120px; /* 显著减少上边距 */
      
      span {
        font-size: 36px; /* 保持一致 */
      }
    }
    
    .reg-sub-desc {
      font-size: 18px; /* 进一步缩小副标题字体 */
      margin-top: 20px; /* 调整间距 */
    }
    
    .reg-btn {
      width: 240px; /* 进一步调整按钮宽度 */
      height: 46px; /* 进一步调整按钮高度 */
      line-height: 46px;
      font-size: 15px; /* 进一步调整按钮字体 */
      margin-top: 45px; /* 调整按钮上边距 */
    }
    
    .apply-progress {
      font-size: 13px; /* 进一步调整链接字体 */
      margin-top: 18px; /* 调整间距 */
    }
  }
}
</style>